import React, { Component } from 'react'
import './index.css';
import IconClose from '../IconClose'
import IconToggle from '../IconToggle'
import { TimeOptions, TimeOptionsLabel } from '../../constants';
import { Tooltip } from '@mui/material';
import { showCurrentTimes } from '../../slice/functions';

class LucketTime extends Component {

    state = {
        edit: false
    }


    edit = () => { this.setState({ edit: !this.state.edit }) }

    toggle = () => {
        let newTimeValue = JSON.stringify({});
        this.props.updateLucket(newTimeValue, "time");
    }

    set = (event, v) => {

        event.stopPropagation();

        let lucket = this.props.lucket;
        let currentTime = lucket.time ? { ...lucket.time } : {}


        currentTime[v] = lucket.time && (lucket.time[v]) ? false : true

        this.props.updateLucket(JSON.stringify(currentTime), "time");
    }

    setPoints = (event, v) => {

        event.stopPropagation();
        if (v === "plus") {
            let lucket = this.props.lucket;
            let currentOrder = lucket.order;
            if (lucket.order && lucket.order < 25) {
                currentOrder += 1;
            }
            if (!lucket.order) { currentOrder = 1 }
            this.props.updateLucket(currentOrder, "order")
        }
        if (v === "minus") {
            let lucket = this.props.lucket;
            let currentOrder = lucket.order;
            if (lucket.order && lucket.order > 1) {
                currentOrder -= 1;
            }
            if (!lucket.order) { currentOrder = 1 }
            this.props.updateLucket(currentOrder, "order")
        }
    }

    render() {


        let timeOptions = TimeOptions;

        const classForOption = (option, lucket) => {
            if (typeof lucket.time === "object" && lucket.time[option]) {
                return 'LucketTimeIconShort HighligtedTimeIcon';
            } else {
                return 'LucketTimeIconShort';
            }

        }

        const timeEditor = (this.state.edit === true) &&
            <div className="TimeEditorWrapper">
                <div className="TimeCallout" />
                <div id="menu" className="TimeMenu">
                    {timeOptions.map((o, i) =>
                        <div title={TimeOptionsLabel[i]} key={o} className={classForOption(o, this.props.lucket)} onClick={(e) => this.set(e, o)} > {o} </div>
                    )}

                    <IconToggle edit={this.toggle} key={"toggle"} />
                    <IconClose edit={this.edit} key={"close"} />

                </div></div>

        let scheduleLength = Object.keys(this.props.lucket.time).length
        let isMoreThan3 = scheduleLength > 3;
        let timeKeys = Object.keys(this.props.lucket.time)
        let activeTimeKeys = timeKeys.filter((timeKey) => this.props.lucket.time[timeKey] === true)

        return (<Tooltip title="Schedule">
            <div className={'LucketTimeIcon'}
                key={"time" + this.props.lucket.id + scheduleLength}
                onClick={this.edit}>
                {activeTimeKeys.length > 0 ? activeTimeKeys.map((v, i) => {
                    return <div className='activeTimeKey'> {v}</div>
                }) : <div id={"lucketTime" + this.props.lucket.rowID} className='activeTimeKey'> T </div>}
                {timeEditor}

            </div>
        </Tooltip>)
    }

}

export default LucketTime